import axios from "axios";
import { API } from "./client";

export async function getNotifications(limit = 50) {
  const res = await axios.get(`${API}/notifications`, { params: { limit } });
  return res.data;
}

export async function getUnreadCount() {
  const res = await axios.get(`${API}/notifications/unread-count`);
  return res.data.count;
}

export async function markRead(id) {
  const res = await axios.patch(`${API}/notifications/${id}/read`);
  return res.data;
}

export async function markAllRead() {
  const res = await axios.patch(`${API}/notifications/read-all`);
  return res.data;
}

export async function deleteNotification(id) {
  const res = await axios.delete(`${API}/notifications/${id}`);
  return res.data;
}

export async function clearAll() {
  const res = await axios.delete(`${API}/notifications/clear`);
  return res.data;
}

/**
 * Subscribe to be notified when a long-running job completes.
 * @param {"evaluation"|"comparison"|"analysis"} jobType
 * @param {string} sessionId
 */
export async function subscribeJobNotification(jobType, sessionId) {
  const endpoints = {
    evaluation: `${API}/sessions/${sessionId}/notify-on-complete`,
    comparison: `${API}/compare/${sessionId}/notify-on-complete`,
    analysis: `${API}/analysis/${sessionId}/notify-on-complete`,
  };
  const url = endpoints[jobType];
  if (!url) throw new Error(`Unknown job type: ${jobType}`);
  const res = await axios.post(url);
  return res.data;
}
